import { navigate, type PageProps } from 'gatsby';
import React from 'react';
import { useSearchParam } from 'react-use';

import { DrilldownHeader } from '@components/DrilldownHeader';
import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';
import * as ROUTES from '@constants/routes';

import { useSession } from '@hooks/useSession';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/DrilldownStyle';

import ClientDrilldown from '@views/Records/LabResults/Drilldown';
import Drilldown from '@views/Records/LabResults/SingleLabDrilldown';

export default function LabResultsReportPage(_props: PageProps) {
  const category = useSearchParam('category');
  const id = useSearchParam('id');
  const title = useSearchParam('title');
  const {
    state: { isClient },
  } = useSession();

  React.useEffect(() => {
    if (!id && !category) {
      navigate(ROUTES.LAB_RESULTS);
    }
  }, [id, category]);

  if (isClient) {
    return (
      <AppLayout friendlyName={title}>
        <DrilldownHeader backRoute={ROUTES.LAB_RESULTS} title={title} />
        <MainContainer maxWidth="800px">
          <ClientDrilldown type={category ?? undefined} title={title} />
        </MainContainer>
      </AppLayout>
    );
  }
  return (
    <RoleGuard roles={[RoleName.Curator, RoleName.Practitioner]}>
      <Drilldown id={id ?? ''} />
    </RoleGuard>
  );
}
